type BookADemoDescriptionDataType = {
  text: string
}

export const bookADemoDescriptionData: BookADemoDescriptionDataType[] = [
  {
    text: 'See the platform in action with examples relevant to your business',
  },
  {
    text: 'Ask questions directly to our product specialist who can address technical details',
  },
  {
    text: 'Learn about the integration platform landscape and how Integration App fits',
  },
  {
    text: 'Get a tailored POC and pricing quote follow up',
  },
]
